import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const AccountPageSkeleton: React.FC = () => (
  <div className="space-y-6">
    <Skeleton className="h-7 w-48" />
    <div className="rounded-lg border p-6 space-y-4">
      <Skeleton className="h-5 w-40" />
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-56" />
        <Skeleton className="h-9 w-32" />
      </div>
    </div>
  </div>
)

export default AccountPageSkeleton
